import json from './sprite.js';

export default {
    handle: 'ENG_SPT5-Birthday_225002526',
    label: 'en_SPT5-Birthday_225002526',
    json,
};
